// Owner allowlist — must match server-side requirePlatformAdmin.ts
const PLATFORM_ADMIN_EMAILS = ['tim@rithmo.ai', 'raghu@rithmo.ai', 'charbel@rithmo.ai']

export function isPlatformAdminEmail(email) {
  return PLATFORM_ADMIN_EMAILS.includes((email ?? '').toLowerCase().trim())
}
